import MobNavbarBtns from "../components/MobNavbarBtns";
import MobNavbarSec from "../sections/MobNavbarSec";
import NavbarSec from "../sections/NavbarSec";
import Segment1 from "../sections/Segment1";
import Segment2 from "../sections/Segment2";
import Segment3 from "../sections/Segment3";
import Segment4 from "../sections/Segment4";
import Segment5 from "../sections/Segment5";

export default function Terms(){
    return(
        <div className="Home">
            <MobNavbarSec/>
            <NavbarSec/>
            <Segment5/>
            </div>
    );
}